/* viho-dots.js
   Three responsibilities:
   1. Sync dot indicators under the featured rotating product card.
   2. Blog dropdown article title marquee.
   3. Mobile touch: prevent mouseenter from stopping the card rotator
      (iOS fires mouseenter on touchstart; the existing inline JS then
      calls stopRotation() and never calls startRotation() again unless
      mouseleave fires, which it often does not on touch).
      Fix: dispatch a fake mouseleave 120ms after each touchstart so
      the existing startRotation() is always called after a tap.
*/
(function () {
  'use strict';

  /* ── 1. DOT INDICATORS ─────────────────────────────────────────── */

  function initDots(rotatorEl, dotsEl, slideSelector) {
    var slides = Array.prototype.slice.call(rotatorEl.querySelectorAll(slideSelector));
    var dots   = Array.prototype.slice.call(dotsEl.querySelectorAll('[class*="featured-dot"]'));
    if (!slides.length || !dots.length) return;

    function syncDots() {
      slides.forEach(function (slide, i) {
        if (dots[i]) {
          dots[i].classList.toggle('is-active', slide.classList.contains('is-active'));
        }
      });
    }

    var observer = new MutationObserver(syncDots);
    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });
    syncDots();

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        slides.forEach(function (s, j) {
          s.classList.toggle('is-active', i === j);
        });
      });
    });
  }

  function setupDots() {
    document.querySelectorAll('[data-viho-dots]').forEach(function (dotsEl) {
      var rotator = dotsEl.previousElementSibling;
      if (rotator && rotator.hasAttribute('data-viho-rotator')) {
        initDots(rotator, dotsEl, '.viho-mega__featured-slide');
      }
    });
    document.querySelectorAll('[data-viho-mini-dots]').forEach(function (dotsEl) {
      var rotator = dotsEl.previousElementSibling;
      if (rotator && rotator.hasAttribute('data-viho-mini-rotator')) {
        initDots(rotator, dotsEl, '.viho-mini__featured-slide');
      }
    });
  }

  /* ── 2. BLOG ARTICLE TITLE MARQUEE ─────────────────────────────── */

  function checkBlogOverflow() {
    document.querySelectorAll('.viho-blogdd__title-text').forEach(function (outer) {
      var inner = outer.querySelector('.viho-blogdd__title-inner');
      if (!inner) return;
      outer.classList.remove('viho-blogdd__title-text--overflow');
      inner.style.removeProperty('--viho-scroll');
      // Temporarily remove max-width so we can measure the text's natural width.
      // Without this, max-width:100% clamps scrollWidth = clientWidth → no overflow detected.
      var prevMax = inner.style.maxWidth;
      inner.style.maxWidth = 'none';
      var naturalWidth = inner.scrollWidth;
      inner.style.maxWidth = prevMax;
      var overflow = naturalWidth - outer.clientWidth;
      if (overflow > 2) {
        inner.style.setProperty('--viho-scroll', '-' + (overflow + 16) + 'px');
        outer.classList.add('viho-blogdd__title-text--overflow');
      }
    });
  }

  function setupBlogMarquee() {
    var blogdd = document.querySelector('[data-viho-blogdd]');
    if (!blogdd) return;
    blogdd.addEventListener('mouseenter', checkBlogOverflow, { once: true });
  }

  /* ── 3. MOBILE TOUCH: KEEP ROTATOR ALIVE ───────────────────────── */

  function setupMobileRotation() {
    // Only relevant on touch/pointer-coarse devices
    if (!window.matchMedia('(pointer: coarse)').matches) return;

    var selectors = ['[data-viho-rotator]', '[data-viho-mini-rotator]'];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (rotator) {
        rotator.addEventListener('touchstart', function () {
          // The inline JS's mouseenter listener will fire shortly and
          // call stopRotation(). We dispatch mouseleave 120ms later so
          // startRotation() is immediately re-triggered, keeping the
          // 4s interval alive.
          setTimeout(function () {
            rotator.dispatchEvent(new MouseEvent('mouseleave', { bubbles: true }));
          }, 120);
        }, { passive: true });
      });
    });
  }

  /* ── INIT ───────────────────────────────────────────────────────── */

  function init() {
    setupDots();
    setupBlogMarquee();
    setupMobileRotation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
